var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isEnabled
    ? _c(
        _setup.Button,
        {
          staticClass: "rounded-0",
          attrs: { disabled: _setup.id === 0 },
          nativeOn: {
            click: function ($event) {
              return _setup.onClick.apply(null, arguments)
            },
          },
        },
        [_c("i", { staticClass: "bi-plus-lg" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }